import { useState } from "react";
import NewProfileModal from "../../Shared/NewTransporterProfileModal/NewProfileModal";
import styles from "./profilemodal.module.css";

const ProfileModal = ({
  transporter_list = [],
  transporter_id = "",
  transporter_name = "",
  screenName = "",
  moduleName = "",
  buttonClass = "",
  style = {},
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <>
      <button
        className={`btn btn-link ${buttonClass} ${styles.profileBtn_wrap_text}`}
        style={style}
        onClick={openModal}
      >
        {transporter_name}
      </button>

      <NewProfileModal
        isOpen={isOpen}
        onClose={closeModal}
        transporter_id={transporter_id}
        transporter_name={transporter_name}
        transporter_list={transporter_list}
      />
    </>
  );
};

export default ProfileModal;
